// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import { Menu, MenuDivider, MenuItem } from '@szhsin/react-menu';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {
  MenuClassName,
  MenuDividerClassName,
  MenuItemClassName,
  MenuItemIconClassName,
} from '../../../../DesignSystem/ContextMenu/ContextMenuStyles';
import Heading from '../../../../generic-components/Heading';
import { reviewContentMap } from '../../consts';
import { ReactComponent as EditIcon } from '../../../../assets/svg/edit-pen.svg';
import { ReactComponent as SwitchIcon } from '../../../../assets/icons/svg/shared/ic-shared-switch.svg';

interface IEditVendorMenuProps {
  handleEditVendor: () => void;
  handleSwitchVendor: () => void;
}

export const EditVendorMenu = (props: IEditVendorMenuProps) => {
  const { handleEditVendor, handleSwitchVendor } = props;
  const { t } = useTranslation();
  const { moveType } = useParams();
  return (
    <Menu
      menuButton={<EditIcon id='editDetials' className='cursor-pointer' />}
      className={MenuClassName}
      transition
      direction='left'
      align='center'
      gap={8}
    >
      <MenuItem id='editPayee' className={MenuItemClassName} onClick={handleEditVendor}>
        <>
          <EditIcon className={MenuItemIconClassName} />
          <Heading
            title={t(reviewContentMap[moveType as keyof typeof reviewContentMap].edit_item)}
            className='font-metricR text-bw07 text-14px'
          />
        </>
      </MenuItem>
      <MenuDivider className={MenuDividerClassName} />
      <MenuItem id='switchPayee' className={MenuItemClassName} onClick={handleSwitchVendor}>
        <>
          <SwitchIcon className={MenuItemIconClassName} />
          <Heading
            title={t(reviewContentMap[moveType as keyof typeof reviewContentMap].switch_item)}
            className='font-metricR text-bw07 text-14px'
          />
        </>
      </MenuItem>
    </Menu>
  );
};
